import React from "react";

const StatCard = ({ icon, label, value, variant }) => {
  const iconStyles = {
    primary: { backgroundColor: "rgba(59, 130, 246, 0.1)", color: "#3b82f6" },
    success: { backgroundColor: "rgba(34, 197, 94, 0.1)", color: "#22c55e" },
    danger: { backgroundColor: "rgba(239, 68, 68, 0.1)", color: "#ef4444" },
    info: { backgroundColor: "rgba(99, 102, 241, 0.1)", color: "#6366f1" },
  };

  return (
    <div
      style={{
        backgroundColor: "#fff",
        borderRadius: "8px",
        padding: "16px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        display: "flex",
        alignItems: "center",
        gap: "16px",
      }}
    >
      <div
        style={{
          ...iconStyles[variant],
          padding: "12px",
          borderRadius: "8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {icon}
      </div>
      <div>
        <p
          style={{
            fontSize: "14px",
            color: "#6b7280",
            fontWeight: "500",
            margin: 0,
          }}
        >
          {label}
        </p>
        <p
          style={{
            fontSize: "24px",
            fontWeight: "700",
            color: "#1f2937",
            margin: 0,
          }}
        >
          {value}
        </p>
      </div>
    </div>
  );
};

export default StatCard;
